import { render } from "./UserNotifications.vue?vue&type=template&id=182d6745&scoped=true"
import script from "./UserNotifications.vue?vue&type=script&lang=js"
export * from "./UserNotifications.vue?vue&type=script&lang=js"

import "./UserNotifications.vue?vue&type=style&index=0&id=182d6745&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182d6745"]])

export default __exports__